/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
/* tslint:disable: no-duplicate-imports */
import * as React from 'react';

import { isMobile } from 'react-device-detect';

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import { IBuyboxViewProps } from '@msdyn365-commerce-modules/buybox';
import {
    IBuyboxAddToCartViewProps,
    IBuyboxAddToOrderTemplateViewProps,
    // IBuyboxAddToWishlistViewProps,
    IBuyboxFindInStoreViewProps,
    IBuyboxKeyInPriceViewProps,
    IBuyboxProductConfigureDropdownViewProps,
    IBuyboxProductConfigureViewProps,
    IBuyboxProductQuantityViewProps
    // IBuyboxShopSimilarLookViewProps
 } from './components';

const BuyboxView: React.FC<IBuyboxViewProps> = props => {
    const { ModuleProps, MediaGalleryContainerProps, ProductInfoContainerProps, addToCart, addToOrderTemplate, configure, description, findInStore, quantity, price, title, rating, inventoryLabel, keyInPrice } = props;
    /*{shopSimilarLook && _renderShopSimilarItem(shopSimilarLook)}
    {addToWishlist && _renderAddToWishlist(addToWishlist)}*/
    return (
    <Module {...ModuleProps}>
      <Node {...MediaGalleryContainerProps}>{props.mediaGallery}</Node>
      <Node {...ProductInfoContainerProps}>
        {title}
        {price}
        {description}
        {rating}
        {configure && _renderConfigure(configure)}
        {keyInPrice && _renderKeyInPrice(keyInPrice)}
        {quantity && _renderQuantity(quantity)}
        {inventoryLabel}
        {!isMobile && (addToCart && _renderAddToCart(addToCart))}
        {findInStore && _renderFindInStore(findInStore)}
        {addToOrderTemplate && _renderAddToOrderTemplate(addToOrderTemplate)}
        { _renderSocialShare(props.slots && props.slots.socialShare)}
      </Node>
    </Module>
    );
};

const _renderAddToCart = (addToCart: IBuyboxAddToCartViewProps): JSX.Element => {
    const { ContainerProps, errorBlock, button, button2 } = addToCart;

    return (
      <Node {...ContainerProps}>
        {errorBlock}
        {button}
        {button2}
      </Node>
    );
};

const _renderAddToOrderTemplate = (addToOrderTemplate: IBuyboxAddToOrderTemplateViewProps): JSX.Element => {
    const { ContainerProps, errorBlock, button } = addToOrderTemplate;

    return (
      <Node {...ContainerProps}>
        {errorBlock}
        {button}
      </Node>
    );
};

const _renderConfigure = (configure: IBuyboxProductConfigureViewProps): JSX.Element => {
    const { ContainerProps, dropdowns } = configure;

    return <Node {...ContainerProps}>{dropdowns.map(_renderConfigureDropdown)}</Node>;
};

const _renderSocialShare = (socialShare: React.ReactNode[]): JSX.Element | undefined => {
    if (!socialShare || socialShare.length === 0) {
      return undefined;
    }

    return <>{socialShare[0]}</>;
};

const _renderConfigureDropdown = (dropdown: IBuyboxProductConfigureDropdownViewProps): JSX.Element => {
    const { ContainerProps, LabelContainerProps, heading, errors, select } = dropdown;

    return (
      <Node {...ContainerProps}>
        <Node {...LabelContainerProps}>
          {heading}
          {errors}
        </Node>
        {select}
      </Node>
    );
};

const _renderFindInStore = (findInStore: IBuyboxFindInStoreViewProps): JSX.Element => {
    const { ContainerProps, storeSelector, heading, description, errors, button, modal, productPickupOptionList } = findInStore;

    return (
      <Node {...ContainerProps}>
        {storeSelector}
        {heading}
        {productPickupOptionList}
        {description}
        {errors}
        {button}
        {modal}
      </Node>
    );
};

const _renderQuantity = (quantity: IBuyboxProductQuantityViewProps): JSX.Element => {
    const { ContainerProps, LabelContainerProps, heading, input, errors } = quantity;

    return (
      <Node {...ContainerProps}>
        <Node {...LabelContainerProps}>
          {heading}
          {errors}
        </Node>
        {input}
      </Node>
    );
};

const _renderKeyInPrice = (keyInPrice: IBuyboxKeyInPriceViewProps): JSX.Element => {
    const {ContainerProps, LabelContainerProps, heading, input } = keyInPrice;

    return(
      <Node {...ContainerProps}>
        <Node {...LabelContainerProps}>{heading}</Node>
        {input}
      </Node>
    );
};

export default BuyboxView;